import React, { FC } from 'react';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import type { IProps } from '~/src/features/videocontrol/pageBlocks/StepsInstall/LocationTabsBlock/types';

import * as ST from './styled';

const SIZE_IMG = {
    width: 254,
    height: 145,
};

export const LocationTabsBlock: FC<IProps> = ({ data, setActiveTab, activeTab }) => {

    return (
        <ST.Container>
            {data.map((elem, key) => (
                <ST.LocationTab key={elem.id} onClick={() => setActiveTab(data[key].id)} isActive={activeTab === elem.id}>
                    <WebpImage urlWebp={elem.imgWebP}>
                        <ST.Image
                            isActive={activeTab === elem.id}
                            src={elem.imgPng}
                            alt={elem.title}
                            width={SIZE_IMG.width}
                            height={SIZE_IMG.height}
                            data-test={'imagePng'}
                        />
                    </WebpImage>
                    <ST.TextBlock isActive={activeTab === elem.id}>
                        <ST.Title data-test={'title'}>
                            {elem.title}
                        </ST.Title>
                        <ST.Subtext data-test={'subtext'}>
                            {elem.subText}
                        </ST.Subtext>
                    </ST.TextBlock>
                </ST.LocationTab>
            ))}
        </ST.Container>
    );
};
